import styled from 'styled-components';
import { COLORS, SIZING } from '../../styles/variables';
import { device } from '../../styles/devices';

export const PriceWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const ModelPriceLabel = styled.div`
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: 0.003px;
  color: ${COLORS.grey60};
  @media ${device.tablet} {
    margin-bottom: 0px;
    font-size: 16px;
  }
  &.msrp {
    margin-top: ${SIZING.unit(1)};
  }
`;

export const ShortDisclaimer = styled.div`
  color: ${COLORS.grey60};
  font-family: 'Audi Type';
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: 0.002px;
`;

export const PricesContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const SecondaryPrice = styled.p`
  display: inline;
  margin-left: ${SIZING.unit(1)};
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0.003px;
  color: ${COLORS.grey80};
  @media ${device.laptop} {
    display: inline;
    margin-top: '';
    margin-left: '';
  }
  @media ${device.laptopL} {
    display: inline;
    margin-left: ${SIZING.unit(1)};
    margin-top: 0;
  }
`;
